
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/programari/[serviceSlug]/[stepSlug]",
      function () {
        return require("private-next-pages/programari/[serviceSlug]/[stepSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/programari/[serviceSlug]/[stepSlug]"])
      });
    }
  